import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiProvider } from "@src/store/ApiProvider";
import { withPasswordManagerRefresh } from "./passwordManagerRequest";

export interface IBulkCredentialItem {
	companyId: number;
	vendorId: number;
	username: string;
	password: string;
	notes: string;
	notificationEmail: string;
	errorMessage: string;
	crawlerId: number;
	teamCode: string;
}

interface IBulkUploadState {
	loading: boolean;
	error: string | null;
}

const initialState: IBulkUploadState = {
	loading: false,
	error: null,
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
		"Content-Type": "application/json",
	};
};

const buildUrl = () => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Credentials`;
};

export const bulkUploadCredentials = createAsyncThunk<undefined, { rows: Array<IBulkCredentialItem> }>(
	"passwordManager/bulkUploadCredentials",
	async ({ rows }, { rejectWithValue, dispatch }) => {
		try {
			await withPasswordManagerRefresh(dispatch, () => axios.post(buildUrl(), rows, { headers: getAuthHeaders() }));
			return undefined;
		} catch (error: unknown) {
			const message = error instanceof Error ? error.message : "Failed to upload credentials";
			return rejectWithValue(message);
		}
	},
);

const bulkUploadCredentialsSlice = createSlice({
	name: "passwordManager/bulkUploadCredentials",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(bulkUploadCredentials.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(bulkUploadCredentials.fulfilled, (state) => {
				state.loading = false;
				state.error = null;
			})
			.addCase(bulkUploadCredentials.rejected, (state, action) => {
				state.loading = false;
				state.error = (action.payload as string) || action.error.message || "Failed to upload credentials";
			});
	},
});

export const bulkUploadCredentialsReducer = bulkUploadCredentialsSlice.reducer;
